export default __webpack_public_path__ + "static/media/product-image.b1972904.jpg";